// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"94593027","513":"1d782a43","703":"97204adb","787":"6cb5844a"}[chunkId] + ".chunk.js";
};